import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {
  // App.vue main toast
  toast: {
    show: false,
    color: 'black',
    message: '',
    timeout: 3000
  },
  sig: {
    show: false,
    messageTitle: null,
    message: null,
    id: 0,
    buttonArray: []
  },
  plainDialog: {
    show: false,
    messageTitle: null,
    message: null,
    buttonArray: []
  },
  //#region Authentication
  useAuthentication: true,
  showLoginDialog: false,
  showCreateAccountDialog: false,
  showForgotPasswordDialog: false,
  authenticating: false,
  isGuest: false,
  isUser: false,
  user: {
    email: '',
    isGuest: false,
    isUser: false,
    id: 0,
    guid: '',
    firstName: '',
    lastName: ''
  }
  //#endregion
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
